import React, { Component } from 'react';
import { Row, Col, FormGroup, FormControl } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { USStates } from '../../constants';
import getContent from './Contents/GoverningLaw';
import Select from '../Select';

export default class GoverningLaw extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showRegionInput: false,
    };
  }

  options = () => ({
    field1: this.props.field1,
    type: 'state',
  });

  handleContent(e) {
    let options = this.options();

    this.setState({ showRegionInput: e.target.value === 'extra_region' });

    options.type = e.target.value === 'extra_region' ? 'region' : 'state';
    options.field1 = e.target.value;
    this.props.updateBlock(this.props.block.id, getContent(options), options);
  }

  handleChangeRegion(e) {
    let options = this.options();

    options.type = 'region';
    options.field1 = e.target.value || 'extra_region';
    this.props.updateBlock(this.props.block.id, getContent(options), options);
  }

  render() {
    let value = this.props.field1;
    if (value && !USStates.includes(value)) {
      value = 'extra_region';
    }

    return (
      <div className="tab-content">
        <Row>
          <Col sm={12}>
            <p className="question">
              Under which region’s law should the terms of this agreement be
              governed?
            </p>
            <FormGroup className="answer">
              <Select
                className="form-control"
                value={value}
                onChange={(e) => this.handleContent(e)}
              >
                <option value="">Please select</option>
                <option value="extra_region">Other</option>
                {USStates.map((state, i) => (
                  <option key={i}>{state}</option>
                ))}
              </Select>

              {(this.state.showRegionInput || value === 'extra_region') && (
                <FormControl
                  type="text"
                  className="form-control region-input"
                  placeholder="Input region"
                  value={
                    this.props.field1 === 'extra_region'
                      ? ''
                      : this.props.field1
                  }
                  onChange={(e) => this.handleChangeRegion(e)}
                />
              )}
            </FormGroup>
          </Col>

          <Col sm={12}>{this.props.children}</Col>

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  Your agreement will be interpreted according to the laws of
                  the region that you choose here. If a dispute arises, it will
                  be initially submitted to a court of law in this region too.
                  Typically, the region in which you live is chosen for
                  convenience, but you can choose any region that you want.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/ContractBlock/GoverningLaw.jsx